<div class="modal-header">
  <h4 class="modal-title pull-left">Validating Service Account</h4>
</div>
<div class="modal-body">
  <div class="mb-1">
    <div [ngSwitch]="state">
      <div *ngSwitchCase="'remote-identity-sa-complete'">
        Validation testing complete.
      </div>
      <div *ngSwitchCase="'remote-identity-sa-validation'">
        Validating the your Service Account credentials.
      </div>
      <div *ngSwitchDefault>
        Uploading your service account file.
      </div>
    </div>
  </div>
  <div class="progress">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [style]="widthStyle"></div>
  </div>
</div>
